import React from "react";
import ButtonHollow from "./ButtonHollow";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCloudDownloadAlt } from "@fortawesome/free-solid-svg-icons";

const ButtonDownloadHollow = ({ label, id, style: userStyles = {}, cypressid, ...props }) => {
  return (
    <div>
      <ButtonHollow label={label} id={id} style={userStyles} cypressid={cypressid} {...props}>
        <FontAwesomeIcon className='font-icon' icon={faCloudDownloadAlt} />
      </ButtonHollow>
    </div>
  );
};

ButtonDownloadHollow.defaultProps = {
  label: "Download",
  cypressid: "download"
};

export default ButtonDownloadHollow;
